export default function MySQL_LN() {
  return (
    <div>
      <h2>MySQL_LN</h2>    </div>
  );
}